<template>
  <div>
    <input type="date" v-model="CountDownDateTime" />&nbsp;&nbsp;
    <button v-on:click="UpdateCountdown($event)">Update</button>
    <br />
    <br />
    <count-down ref="cdtimer" v-bind:date="CountDownTimerDate"  />
    <br />
    <br />
  </div>
</template>

<script>
import CountDown from "@/components/CountDown";
export default {
  name: "CountDownView",
  components: { CountDown },
  data: () => {
    let today = new Date();
    return {
      CountDownDateTime: today.toDateString()
    };
  },
  computed: {
    CountDownTimerDate: {
      get() {
        let vm = this;
        let inputDt = new Date(vm.CountDownDateTime);
        return inputDt.toUTCString();
      }
    }
  },
  methods: {
    UpdateCountdown: function(evt) {
      evt.preventDefault();
      let vm = this;
      vm.$refs.cdtimer.updateTimer(vm.CountDownTimerDate);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
